<div class="mainstepcontent row w100">
  <div class="leftside col grow-1 gap-24">
    <div class="col gap-16 w100">
      <div class="col">
        <div class="stepcounter">
          STEP {{ thisStepCount }}/{{ totalStepCount }}
        </div>
        <h1>{{ step?.stepTypeName }}</h1>
      </div>
      <div
        class="instructions align-center row gap-8 pointer"
        (click)="openInstructions()"
      >
        <rr-icon name="info"></rr-icon>
        <div class="underline">Instructions</div>
      </div>
    </div>
    <div class="innerstep col">
      <h3 class="disabled" (click)="setStep(1)" *ngIf="activeStep !== 1">
        The problem I solve
      </h3>
      <rr-ai-control
        *ngIf="activeStep === 1"
        text1="The"
        text2="problem"
        text3="I solve"
        [control]="problemFormCOntrol"
        placeholder="Describe the key challenge your idea addresses..."
        (next)="nextStep()"
      ></rr-ai-control>
    </div>
    <div class="innerstep col">
      <h3 class="disabled" *ngIf="activeStep !== 2" (click)="setStep(2)">
        The first people who will use my product
      </h3>
      <rr-ai-control
        *ngIf="activeStep === 2"
        text1="The"
        text2="first people"
        text3="who will use my product"
        [control]="userFormCOntrol"
        (next)="nextStep()"
      ></rr-ai-control>
    </div>
    <div class="innerstep col">
      <h3 class="disabled" *ngIf="activeStep !== 3" (click)="setStep(3)">
        The solution in a nutshell
      </h3>
      <rr-ai-control
        *ngIf="activeStep === 3"
        text1="The"
        text2="solution"
        text3="in a nutshell"
        [control]="solutionFormCOntrol"
        (next)="nextStep()"
      ></rr-ai-control>
    </div>
    <rr-divider></rr-divider>
    <div class="proceed col gap-16">
      <h4 class="strong">How shall we proceed?</h4>
      <div class="row gap-16 align-center">
        <rr-btn type="Primary" [disabled]="saveStreamStepDisabledStatus"
          >Save Result</rr-btn
        >
        <rr-btn type="Link" class="underline">Reset & Start Again</rr-btn>
      </div>
    </div>
  </div>
  <div class="rightside col">
    <img src="/stepimages/basic-idea.png" alt="" />
  </div>
</div>
<div class="footer row align-center">
  <div class="leftside row gap-16 align-center">
    <rr-btn type="Primary" [disabled]="nextStreamStepDisabledStatus"
      >Next Step</rr-btn
    >
    <rr-btn type="Link" iconStart="arrow-left" size="medium">Back</rr-btn>
  </div>
  <div class="middle row grow-1 align-center justify-center">
    <div class="inner align-center row">
      <div class="stepcounter">
        STEP {{ thisStepCount }}/{{ totalStepCount }}
      </div>
      <rr-progress [progress]="progress"></rr-progress>
    </div>
  </div>
  <div class="rightside row gap-16 align-center">
    <rr-btn type="Secondary" size="Small" iconStart="upload"
      >Upload Knowledge</rr-btn
    >
    <rr-btn type="Secondary" size="Small" iconStart="add">Show Result</rr-btn>
  </div>
</div>
